import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed, ref, watch} from 'vue';
import DatePicker from '../DatePicker.vue';
import Sorter from '../Sorter.vue';
import useSuggestionsStore from '@/store/suggestions';
import {useFilterSort} from '@/composables/filterSort';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSuggestion',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;
const store = useSuggestionsStore();
const {filters, save, sorts, SortTypes, reset} = useFilterSort(store, emits);

const sortableFields = ref([
  {
    text: 'Buchung-Nr.',
    value: 'BuchungNr',
  },
  {
    text: 'Datum',
    value: 'ErstelltAm',
  },
]);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

const BuchungNr = computed({
  get() {
    return filters.value.BuchungNr;
  },
  set(BuchungNr: number | undefined) {
    filters.value.BuchungNr = BuchungNr;
  },
});
const ErstelltAmFrom = computed({
  get() {
    return filters.value.ErstelltAm$From;
  },
  set(val: string | undefined) {
    if (!val) filters.value.ErstelltAm$From = undefined;
    else filters.value.ErstelltAm$From = val;
  },
});
const ErstelltAmTo = computed({
  get() {
    return filters.value.ErstelltAm$To;
  },
  set(val: string | undefined) {
    if (!val) filters.value.ErstelltAm$To = undefined;
    else filters.value.ErstelltAm$To = val;
  },
});
const ErstelltDurch = computed({
  get() {
    return filters.value.ErstelltDurch;
  },
  set(val: string | undefined) {
    if (!val) filters.value.ErstelltDurch = undefined;
    else filters.value.ErstelltDurch = val.toUpperCase();
  },
});

function ruleInt(val: string | number | undefined | null): string|true {
  if (!val) return true;

  if (parseInt(val as string).toString() !== val.toString()) return 'bitte eine ganze Zahl eingeben';

  return true;
}
function ruleUserShort(val: string | undefined | null): string|true {
  if (!val) return true;

  if (val.length > 5) return 'zu lang';

  return true;
}

watch(form, () => {
  form.value?.validate();
});

__expose({
  save, sorts, SortTypes, reset,
  ruleInt,
  ruleUserShort,
  sortableFields,
  form,
  BuchungNr,
  ErstelltAmFrom,
  ErstelltAmTo,
  ErstelltDurch,
  Sorter, DatePicker,
});


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            start: "",
            color: "grey"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-filter")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(" Filter "),
          _createVNode(_component_v_icon, {
            onClick: _unref(save),
            class: "ml-auto",
            end: "",
            color: "grey"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "px-3 py-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, null, {
            default: _withCtx(() => [
              _createVNode(Sorter, {
                modelValue: _unref(sorts),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sorts) ? (sorts).value = $event : null)),
                sortableFields: sortableFields.value,
                SortTypes: _unref(SortTypes),
                clearable: ""
              }, null, 8, ["modelValue", "sortableFields", "SortTypes"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_v_form, { ref: form.value }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: BuchungNr.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((BuchungNr).value = $event)),
                modelModifiers: { number: true },
                rules: [ruleInt],
                variant: "outlined",
                "hide-details": "",
                placeholder: "Buchungs-Nr.",
                class: "mb-4",
                clearable: ""
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_select, {
                modelValue: _unref(filters).Erledigt,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).Erledigt) = $event)),
                "item-title": "text",
                "item-value": "value",
                items: [{value: true, text: 'Ja'}, {value: false, text: 'Nein'}],
                label: "Erledigt",
                clearable: ""
              }, null, 8, ["modelValue"]),
              _createVNode(DatePicker, {
                modelValue: ErstelltAmFrom.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ErstelltAmFrom).value = $event)),
                label: "Datum von"
              }, null, 8, ["modelValue"]),
              _createVNode(DatePicker, {
                modelValue: ErstelltAmTo.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ErstelltAmTo).value = $event)),
                label: "Datum bis"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: ErstelltDurch.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ErstelltDurch).value = $event)),
                rules: [ruleUserShort],
                variant: "outlined",
                "hide-details": "",
                label: "Erstellt durch",
                maxlength: "5",
                clearable: ""
              }, null, 8, ["modelValue", "rules"])
            ], undefined, true),
            _: 1
          }, 512)
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_actions, { class: "text-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "grey",
            class: "flex-1",
            variant: "outlined",
            size: "large",
            onClick: _unref(reset)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Zurücksetzen")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            class: "flex-1 btn-navigator-primary",
            size: "large",
            onClick: _unref(save)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Speichern")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}
}

})